import { ContractContext } from "../context/contractsContext"
import { useContext } from "react"

export const useContractContext = () => {
  const context = useContext(ContractContext)

  if(!context) {
    throw Error('useAuthContext must be used inside an AuthContextProvider')
  }

  return context
}